import { apiUserSegmentations } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useUserSegmentationByIds = (segmentationIds: number[]) => {
  return useQuery({
    queryKey: ['useUserSegmentationByIDs', segmentationIds],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiUserSegmentations.fetchSegmentationTypesByIds({
          segmentationIds,
          language: 'EN',
        });
        return response;
      }
    },
    enabled: segmentationIds && segmentationIds.length > 0,
  });
};

export const useUserSegmentation = (search: string) => {
  return useQuery({
    queryKey: ['useUserSegmentation', search],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiUserSegmentations.fetchSegmentationTypes({
          search,
          size: '20',
          language: 'EN',
        });
        return response;
      }
    },
  });
};

export const useAllSegmentations = (search: string) => {
  return useQuery({
    queryKey: ['useUserSegmentation', search],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiUserSegmentations.fetchSegmentationTypes({
          search,
          size: '10',
          language: 'EN',
        });
        return response;
      }
    },
  });
};
